import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SyncLockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sync_lock"}/>
}
